<template>
  <div id="Foot">
    <img src="../assets/public/3.png" />
    <div>
      <div>
        <div>
          <img src="../assets/public/5.png" />
        </div>
        <div>
          <div>联系地址：</div>
          <div>北京市朝阳区和平街十三区煤炭大厦（100013）</div>
        </div>
      </div>
      <div>
        <div>
          <img src="../assets/public/6.png" />
        </div>
        <div>
          <div>技术支持：</div>
          <div>浙江大学台州研究院</div>
        </div>
      </div>
      <div>
        <div>
          <img src="../assets/public/7.png" />
        </div>
        <div>
          <div>传真号码：</div>
          <div>(010)64463614</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Foot",
  data() {
    return {};
  },
};
</script>
<style scope lang="less">
#Foot {
  min-width: 1000px;
  width: 100%;
  position: absolute;
  left: 0px;
  bottom: 0px;
  z-index: 999;
  height: 1.2rem;
  > img {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
  > div {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 1.35rem;
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 0.16rem;
    > div {
      display: flex;
      align-items: center;
      color: #ffffff;
      width: 100%;
      justify-content: center;
      > div {
        & > div:last-child {
          margin-top: 0.05rem;
        }
      }
      & > div:first-child {
        height: 0.75rem;
        width: 0.75rem;
        margin-right: 0.1rem;
        border: 0.01rem solid #d9d9d9;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 0.35rem;
          width: 0.35rem;
        }
      }
    }
  }
}
</style>
